import type { UseQueryOptions, UseQueryResult } from "react-query";
import { useQuery } from "react-query";

import type { GetUserCourseResponse } from "api/schemas/UserCourse";
import { useApiClient } from "api/useApiClient";

export const GET_USER_COURSE_QUERY_KEY = "useGetUserCourseQuery";
type QueryKey = [typeof GET_USER_COURSE_QUERY_KEY, number];

export const getUserCourseQueryKey = (args: { patientId: number }): QueryKey => [
  GET_USER_COURSE_QUERY_KEY,
  args.patientId,
];

export const useGetUserCourseQuery = (
  args: { patientId: number },
  options?: UseQueryOptions<GetUserCourseResponse, Error, GetUserCourseResponse, QueryKey>
): UseQueryResult<GetUserCourseResponse, Error> => {
  const client = useApiClient();
  return useQuery(
    [GET_USER_COURSE_QUERY_KEY, args.patientId],
    () => {
      return client.getUserCourse(args.patientId);
    },
    options
  );
};
